export enum Coberturas {
  MODALIDADE = "Modalidade",
  DANOS_MATERIAIS = "Danos materiais",
  DANOS_CORPORAIS = "Danos corporais",
  DANOS_MORAIS = "Danos morais",
  INVALIDEZ = "APP - Invalidez",
  MORTE = "APP - Morte",
}
